import styled from "styled-components";
import { Button } from "storybook/components/button";
import { tablet, mobile } from "styles/breakpoints";
import { defaultTheme } from "storybook/themes/default";

const { colors } = defaultTheme;

export const VideoContainer = styled.div`
  max-width: 780px;
  overflow: hidden;
  flex: 2;

  .video-container {
    border-radius: 8px;
  }
`;

export const InfoSection = styled.div`
  justify-content: space-between;
  display: flex;
  width: 100%;
  gap: 10px;

  @media (min-width: ${tablet}px) {
    gap: 20px;
  }

  @media (max-width: ${mobile}px) {
    flex-direction: column;
  }
`;

export const IconWrapper = styled.span`
  margin-right: 10px;
  display: flex;
  align-items: center;
`;

// @ts-ignore cannot resolve against default theme
export const RadioButton = styled(Button).attrs({
  theme: "default",
  variant: "outlined",
  color: "default",
})<{ selected?: boolean }>`
  && {
    border-color: #323ebe !important;
    background-color: ${({ selected }) =>
      selected ? `#32BE6C` : `white`} !important;
    color: ${({ selected }) =>
      selected ? colors.white : colors.ciqBrandDark} !important;
    text-transform: none !important;
  }

  &&:focus {
    border-color: #323ebe !important;
    outline: none !important;
    background-color: #32be6c !important;
    color: ${({ selected }) =>
      selected ? colors.white : colors.ciqBrandDark} !important;
  }

  &&:hover {
    background-color: ${({ selected }) =>
      selected ? `#32BE6C` : colors.white} !important;
    color: ${({ selected }) =>
      selected ? colors.white : colors.ciqBrandDark} !important;
  }

  @media (max-width: ${mobile}px) {
    white-space: normal !important;
    text-align: center;
    word-spacing: 100px;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 10px;
  margin-bottom: 15px;

  > label {
    flex: 1;
    align-items: stretch;
  }

  > label > input {
    //  For some reason, without this the page jumps to the top whenver a radio button is selected
    visibility: hidden;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 25px;

  && {
    button {
      text-transform: none;
    }
  }
`;

export const ReasonsContainer = styled.div`
  li {
    padding-bottom: 16px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InstructionsText = styled.div`
  && {
    h2 {
      color: #323ebe;
      font-weight: 700;
    }
  }
`;
